 import React from 'react';

 const FootNote = ({userActivity}) => (
	<p style={{fontSize: "13px",paddingTop:"0"}}>By clicking "{userActivity}", you acknowledge that you have read our updated <a href="https://step.thehindu.com/termsandconditions">Terms & Conditions </a> and <a href="https://step.thehindu.com/privacy">Privacy statement</a> and that your continued use of the website is subject to these policies.</p>
)

 export default FootNote;